import { render, staticRenderFns } from "./ProductStockValue.vue?vue&type=template&id=9a3c7ad8&"
import script from "./ProductStockValue.vue?vue&type=script&lang=js&"
export * from "./ProductStockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports